import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ScaleIcon from "@mui/icons-material/Scale";
import InfoRow from "../common/InfoRow";
import LabelIcon from "@mui/icons-material/Label";
import { QuantityUnitResponseDto } from "../../shared/dtos/quantityUnit/QuantityUnitResponseDto";

interface QuantityUnitCardProps {
  unit: QuantityUnitResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const QuantityUnitCard: React.FC<QuantityUnitCardProps> = ({
  unit,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header */}
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              spacing: 1.5,
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <ScaleIcon fontSize="small" />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }} noWrap>
                {unit.name}
              </Typography>
            </Box>
          </Stack>

          <Stack sx={{ flexDirection: "row" }}>
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        {/* Details Body */}
        <Stack sx={{ spacing: 2, flexGrow: 1, gap: 2 }}>
          <InfoRow
            icon={<LabelIcon fontSize="small" />}
            label="Short Code"
            value={
              <Chip
                label={unit.code}
                size="small"
                variant="outlined"
                sx={{ fontWeight: "bold" }}
              />
            }
          />
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default QuantityUnitCard;
